// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>6</span>&nbsp;&nbsp;With the praises of God in their mouths&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;and a two-edged sword in their hands;<br> </p> </div></div>";
// Exports
module.exports = code;